module.exports = __webpack_public_path__ + "static/img/1.7b20aa0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/3/eng/1.png
// module id = q8DH
// module chunks = 0